import React from "react";
import usePlugins from "../components/Plugins/hooks/usePlugins";
import FeaturedPluginsComponent from "../components/FeaturedPlugins";

export default function FeaturedPlugins(props) {
  const { plugins, pluginCategories, isLoading, error } = usePlugins();

  console.log(pluginCategories);

  return (
    <>

      <h2>Homepage</h2>

      <FeaturedPluginsComponent />

      {pluginCategories &&
        pluginCategories.map((category) => (
          <>
            <h2 key={category.id}>{category.name}</h2>
            <FeaturedPluginsComponent key={category.id} pluginCategory={category} />
          </>
        ))}
    </>
  );
}
